import { render, staticRenderFns } from "./CreditLimit.vue?vue&type=template&id=01d0318e"
import script from "./CreditLimit.vue?vue&type=script&lang=js"
export * from "./CreditLimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01d0318e')) {
      api.createRecord('01d0318e', component.options)
    } else {
      api.reload('01d0318e', component.options)
    }
    module.hot.accept("./CreditLimit.vue?vue&type=template&id=01d0318e", function () {
      api.rerender('01d0318e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/funders/view/CreditLimit.vue"
export default component.exports